
/**
 * Abre uma url em uma nova aba
 * @param link Link que será aberto
 */
export const abrirEmNovaAba = (link: string) => {
    console.log(link);
    window.open(link, '_blank');
}